import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Select, Table } from 'app/components';
import { ACTION_ITEMS, COLUMN_CONFIG } from './constants';
import { deleteRequestedEvent, editRequestedEvent, getRequestedEventsList } from './api';

const AdminRequestedEventsList = () => {
  const [editConfig, setEditConfig] = useState(null);
  const { eventList, filters, totalPages } = useSelector((state) => state.adminRequestedEventList);
  const dispatch = useDispatch();

  useEffect(() => {
    getRequestedEventsList({ ...filters });
  }, [filters]);

  const onChangeTableData = (key, value) => {
    const filterKey = key === 'search' ? 'searchText' : key;

    if (filters?.[filterKey] !== value) {
      dispatch({
        type: 'ADMIN_REQUESTED_EVENT_LIST:FILTERS:SET',
        data: {
          ...filters,
          [filterKey]: value,
          ...(filterKey !== 'page_no' && ({
            page_no: 1,
          })),
        },
      });
    }
  };

  const onClickActionItem = (actionItem, row) => {
    if (actionItem.action === 'delete') {
      deleteRequestedEvent(row?._id, () => {
        if (filters?.page_no !== 1) onChangeTableData('page_no', 1);
        else getRequestedEventsList(filters);
      });
    } else if (actionItem.action === 'edit') {
      setEditConfig(row);
    }
  };

  const onChangeStatus = () => {
    editRequestedEvent(editConfig?._id, editConfig, () => {
      getRequestedEventsList({ ...filters });
      setEditConfig(null);
    });
  };

  return (
    <div className="flex flex-col gap-4 p-5 admin-requested-events-list">
      <Table
        totalPages={totalPages}
        showSearch={false}
        columns={COLUMN_CONFIG}
        rows={eventList}
        selectedPage={filters?.page_no}
        onChange={onChangeTableData}
        actionItems={ACTION_ITEMS}
        onClickActionItem={onClickActionItem}
      />
      <Modal
        primaryText="Save"
        size="regular"
        isOpen={!!editConfig}
        onClickPrimaryCta={onChangeStatus}
        onClickSecondaryCta={() => setEditConfig(null)}
        title="Edit Status"
      >
        <div className="flex flex-col gap-6">
          <div className="heading-16">Select Status</div>
          <div className="flex gap-6 w-full">
            <Select
              className="grow"
              label="Rejected"
              selected={editConfig?.status === 'Rejected'}
              onClick={() => setEditConfig((prev) => ({ ...prev, status: 'Rejected' }))}
            />
            <Select
              className="grow"
              label="Approved"
              selected={editConfig?.status === 'Approved'}
              onClick={() => setEditConfig((prev) => ({ ...prev, status: 'Approved' }))}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AdminRequestedEventsList;
